import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/site/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="Seite nicht gefunden (404) | FINABLE"
        description="Die angeforderte Seite existiert nicht. Kehre zur FINABLE Startseite zurück und finde unabhängige Finanzberatung."
        canonical="https://finable.de/404"
      />
      <main className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <a href="/" className="text-primary underline hover:text-primary/90">
            Return to Home
          </a>
        </div>
      </main>
    </>
  );
};

export default NotFound;
